import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch book same day cleaning list data
export const getCustomerUpdateProfile = createAsyncThunk(
  "customerUpdateProfile/getCustomerUpdateProfile",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/customer/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

const customerUpdateProfileSlice = createSlice({
  name: "customerUpdateProfile",
  initialState: {
    loading: false,
    customerUpdateProfileData: null,
    error: null,
  },
  reducers: {
    ResetCustomerUpdateState: (state) => {
      state.loading = false;
      state.customerUpdateProfileData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerUpdateProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCustomerUpdateProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.customerUpdateProfileData = action.payload;
      })
      .addCase(getCustomerUpdateProfile.rejected, (state, action) => {
        state.loading = false;
        state.customerUpdateProfileData = action.payload;
        state.error = action.payload;
      });
  },
});

export const { ResetCustomerUpdateState } = customerUpdateProfileSlice.actions;
export default customerUpdateProfileSlice.reducer;
